<div class="transaction-property-detail">
    <app-child-breadcum [property_uid]="propertyInfo?.property_uid" (back)="backToTransaction()"></app-child-breadcum>
    <ng-container *ngIf="allDataLoading">
        <app-skeleton-loader [reportType]="chartView.overView" [loaderSize]="1"  [height]="'150px'"></app-skeleton-loader>
    </ng-container>
    <app-property-details-overview [Property_Uid]="propertyInfo?.property_uid"></app-property-details-overview>
</div>
